export default __webpack_public_path__ + "images/Ski_Family_V01.mp4";